/*
  NOTE: IF CHANGING ANY STANDARD COLOR, PLEASE UPDATE THE VALUES ON utils/getPalleteColor
*/

const spacing = (size: number) => `${size * 10}px`;

export default spacing;
